import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EMPTY, switchMap} from 'rxjs';
import {RemoveWalletUseCase} from "@features/wallet/application/use-cases/remove-wallet.use-case";
import {ActivateWalletUseCase} from "@features/wallet/application/use-cases/activate-wallet.use-case";
import {WalletStatusChangedEvent} from "@platform/event-bus/domain/events/wallet/wallet-status-changed.event";
import {EventBusPort} from "@platform/event-bus/domain/ports/event-bus.port";

@Injectable({providedIn: 'root'})
export class WalletOnStatusChangedSubscriber {
  private readonly eventBus = inject(EventBusPort);
  private readonly destroyRef = inject(DestroyRef);
  private readonly activateWalletUseCase = inject(ActivateWalletUseCase);
  private readonly removeWalletUseCase = inject(RemoveWalletUseCase);

  constructor() {
    this.eventBus.ofType(WalletStatusChangedEvent).pipe(
      switchMap(({payload}) => {
        if (payload.isActive) {
          this.activateWalletUseCase.execute();

          return EMPTY;
        }

        return this.removeWalletUseCase.execute();
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }
}
